// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.groupParticipantsTable {
  min-height: 500px;
}

.groupParticipantsGrid {
  width: 100% !important;
}

.groupParticipantsError {
  margin: 20px 0;
}

.groupParticipantsActions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
  gap: 16px;
}

.groupParticipantsFilter {
  flex-shrink: 0;
}

.groupParticipantRole {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 4px 10px;
  border: 1px solid;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  white-space: normal;
  overflow-wrap: anywhere;
  color: #4d4d4d;
}

.groupParticipantRole-admin {
  background-color: #e8f4fb;
  border-color: #007bc0;
  color: #007bc0;
}

.groupParticipantRole-participant {
  background-color: #f2f2f2;
  border-color: #cccccc;
}

.groupParticipantActions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  flex-wrap: nowrap;
}

.groupParticipantActionButton {
  padding: 6px 8px;
  border: 2px solid #007bc0;
  background: transparent;
  color: #007bc0;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  border-radius: 2px;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.groupParticipantActionButton:hover {
  background-color: #d1e4ff;
}

.groupParticipantDeleteButton {
  cursor: pointer;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
}

.groupParticipantAdminWarning {
  margin: 12px 0 0;
  color: #4d4d4d;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  font-family: 'Bosch Sans', sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/componentes/ConfigGrupos/participantesGrupoTable.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC","sourcesContent":[".groupParticipantsTable {\n  min-height: 500px;\n}\n\n.groupParticipantsGrid {\n  width: 100% !important;\n}\n\n.groupParticipantsError {\n  margin: 20px 0;\n}\n\n.groupParticipantsActions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 16px;\n  gap: 16px;\n}\n\n.groupParticipantsFilter {\n  flex-shrink: 0;\n}\n\n.groupParticipantRole {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  justify-content: center;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  padding: 4px 10px;\n  border: 1px solid;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.2;\n  text-align: center;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  color: #4d4d4d;\n}\n\n.groupParticipantRole-admin {\n  background-color: #e8f4fb;\n  border-color: #007bc0;\n  color: #007bc0;\n}\n\n.groupParticipantRole-participant {\n  background-color: #f2f2f2;\n  border-color: #cccccc;\n}\n\n.groupParticipantActions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  flex-wrap: nowrap;\n}\n\n.groupParticipantActionButton {\n  padding: 6px 8px;\n  border: 2px solid #007bc0;\n  background: transparent;\n  color: #007bc0;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  line-height: 1.2;\n  border-radius: 2px;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n\n.groupParticipantActionButton:hover {\n  background-color: #d1e4ff;\n}\n\n.groupParticipantDeleteButton {\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.groupParticipantAdminWarning {\n  margin: 12px 0 0;\n  color: #4d4d4d;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n  font-family: 'Bosch Sans', sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
